import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-module',
  templateUrl: './pricing-module.component.html',
  styleUrls: ['./pricing-module.component.scss']
})
export class PricingModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
